'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSelect = require('react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CategoriesBox = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(CategoriesBox, _Component);

  function CategoriesBox() {
    (0, _classCallCheck3.default)(this, CategoriesBox);
    return (0, _possibleConstructorReturn3.default)(this, (CategoriesBox.__proto__ || (0, _getPrototypeOf2.default)(CategoriesBox)).apply(this, arguments));
  }

  (0, _createClass3.default)(CategoriesBox, [{
    key: 'onValuesChange',
    value: function onValuesChange(values) {
      var onChange = this.props.onChange;


      var tags = this.getCategoryFromValues(values.filter(function (c) {
        return c.value.indexOf('tag-') === 0;
      }));
      var types = this.getCategoryFromValues(values.filter(function (c) {
        return c.value.indexOf('type-') === 0;
      }));

      onChange(tags, types);
    }
  }, {
    key: 'getCategoryFromValues',
    value: function getCategoryFromValues(values) {
      return values.map(function (v) {
        var _v$value$split = v.value.split('-'),
            _v$value$split2 = (0, _slicedToArray3.default)(_v$value$split, 2),
            id = _v$value$split2[1];

        return {
          id: id,
          name: v.label
        };
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          categories = _props.categories,
          selectedCategories = _props.selectedCategories,
          polyglot = _props.polyglot;

      var options = categories.map(function (c) {
        return { value: c.model + '-' + c.id, label: c.name };
      });
      var tagValues = selectedCategories.tags.map(function (c) {
        return { value: 'tag-' + c.id, label: c.name };
      });
      var typeValues = selectedCategories.types.map(function (c) {
        return { value: 'type-' + c.id, label: c.name };
      });
      var values = [].concat((0, _toConsumableArray3.default)(tagValues), (0, _toConsumableArray3.default)(typeValues)).sort(function (a, b) {
        return a > b;
      });

      return _react2.default.createElement(
        'div',
        { className: 'event-categories-box' },
        _react2.default.createElement(_reactSelect2.default, {
          isMulti: true,
          className: 'react-select',
          classNamePrefix: 'react-select',
          options: options,
          value: values
          // onInputChange={::this.onSearchChange}
          , onChange: this.onValuesChange.bind(this),
          placeholder: polyglot.t('events.categoriesBox.choose')
        })
      );
    }
  }]);
  return CategoriesBox;
}(_react.Component), _class.propTypes = {
  categories: _propTypes2.default.array,
  selectedCategories: _propTypes2.default.object,
  onChange: _propTypes2.default.func.isRequired,
  polyglot: _propTypes2.default.object.isRequired
}, _temp);
exports.default = CategoriesBox;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Form/CategoriesBox.js
// module id = 2201
// module chunks = 0